import { render, staticRenderFns } from "./CompanyInfoBody.vue?vue&type=template&id=0b578b8e&"
import script from "./CompanyInfoBody.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports